export default __webpack_public_path__ + "static/media/add_link_ko.1de3993b.png";